import api from '@/services/api';
import type { RoleRequest, RoleRequestOptions } from '@/types/roleRequest';

export async function fetchMyRoleRequestOptions(): Promise<RoleRequestOptions> {
  const response = await api.get<RoleRequestOptions>('/users/me/role-request/options');
  return response.data;
}

export async function fetchMyRoleRequest(): Promise<RoleRequest | null> {
  const response = await api.get<RoleRequest | null>('/users/me/role-request');
  return response.data;
}

export async function createRoleRequest(payload: {
  requested_user_type_id: number;
  specialty_ids: number[];
}): Promise<RoleRequest> {
  const response = await api.post<RoleRequest>('/users/me/role-request', payload);
  return response.data;
}

export async function fetchRoleRequests(status?: string): Promise<RoleRequest[]> {
  const response = await api.get<RoleRequest[]>('/role-requests', {
    params: status ? { status } : undefined,
  });
  return response.data;
}

export async function approveRoleRequest(id: number, adminNotes?: string): Promise<RoleRequest> {
  const response = await api.post<RoleRequest>(`/role-requests/${id}/approve`, {
    admin_notes: adminNotes || '',
  });
  return response.data;
}

export async function rejectRoleRequest(id: number, adminNotes: string): Promise<RoleRequest> {
  const response = await api.post<RoleRequest>(`/role-requests/${id}/reject`, {
    admin_notes: adminNotes,
  });
  return response.data;
}
